import { Alert, SelectedSource } from '@aloft/toolkit-shared';

import { SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';

const ALERT_TRIGGERS = [
  'navigate/market',
  'navigate/cost-approach',
  'navigate/adjustments',
  'navigate/commentary',
  'navigate/reconciliation',
];

export const inconsistentSubjectGLA: AlertDefinition = ({
  propertyDataEntities,
  conflictedFields,
}) => {
  const subjectEntity = propertyDataEntities.subject as SubjectPropertyDataState;

  const foundConflict = Object.values(conflictedFields).find(
    (conflict) =>
      conflict.fieldName === 'editableData.improvements.gla' && conflict.propertyId === 'subject',
  );

  if (!foundConflict) return undefined;

  const conflictIsResolved = (
    subjectEntity.subjectData.selectedSources?.editableData?.improvements?.gla as
      | SelectedSource
      | undefined
  )?.conflictIsResolved;

  const fixingInfo: Alert['fixingInfo'] = {
    fixingMethod: ['action', 'comment'],
    commentAlwaysRequired: true,
    targetCellKey: 'subject-editableData.improvements.gla',
    pairedCostRouteItem: 'features',
    tips: '',
  };

  const message = "Subject's GLA has conflicting values between data sources.";

  if (foundConflict) {
    if (!conflictIsResolved) {
      return {
        type: 'inconsistentSubjectGLA',
        message,
        severity: 'error',
        status: 'active',
        orderType: ['appraisify'],
        triggers: ALERT_TRIGGERS,
        propertyID: 'subject',
        fixingInfo: {
          ...fixingInfo,
          tips: 'Review all sources and reconcile the conflict, and provide an explanation for the selected value.',
        },
      } as Alert;
    }
    return {
      type: 'inconsistentSubjectGLA',
      message,
      severity: 'error',
      status: 'resolved_pending_comment',
      orderType: ['appraisify'],
      propertyID: 'subject',
      triggers: ALERT_TRIGGERS,
      fixingInfo: {
        ...fixingInfo,
        tips: 'Please provide detailed commentary explaining the rationale behind the selected value for GLA.',
      },
    } as Alert;
  }

  return undefined;
};
